if (!customElements.get('life-dates-product-tabs')) {
  customElements.define('life-dates-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.tabList = this.querySelector('.life-dates-tab-list');
      this.previousTabs = this.querySelector('[data-tab-scroll="previous"]');
      this.nextTabs = this.querySelector('[data-tab-scroll="next"]');
      this.buttons = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.buttons.length) return;
      this.activate(Math.min(Number(this.dataset.initial) || 0, this.buttons.length - 1));
      this.setAttribute('data-enhanced', 'true');
      this.tabList.addEventListener('scroll', () => this.updateScrollButtons(), {passive:true, signal:this.controller.signal});
      [this.previousTabs, this.nextTabs].forEach(button => button.addEventListener('click', () => {
        const direction = button.dataset.tabScroll === 'next' ? 1 : -1;
        this.tabList.scrollBy({left:direction * this.tabList.clientWidth * .65,
          behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal:this.controller.signal}));
      this.tabResize = new ResizeObserver(() => this.updateScrollButtons());
      this.tabResize.observe(this.tabList);
      requestAnimationFrame(() => this.revealTab(this.buttons.find(button => button.getAttribute('aria-selected') === 'true')));
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.activate(index), {signal: this.controller.signal});
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(next);
          this.buttons[next].focus();
        }, {signal: this.controller.signal});
      });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.block === event.detail.blockId);
        if (index >= 0) this.activate(index);
      }, {signal: this.controller.signal});
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const index = this.buttons.findIndex(button => '#' + button.dataset.anchor === link.getAttribute('href'));
        if (index < 0) return;
        event.preventDefault();
        this.activate(index);
        this.querySelectorAll('.life-dates-mobile-details details').forEach((details, position) => { details.open = position === index; });
        this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
        this.buttons[index].focus({preventScroll:true});
      }, {signal:this.controller.signal});
    }
    updateScrollButtons() {
      this.previousTabs.disabled = this.tabList.scrollLeft <= 1;
      this.nextTabs.disabled = this.tabList.scrollLeft + this.tabList.clientWidth >= this.tabList.scrollWidth - 1;
    }
    revealTab(button) {
      if (!button || !matchMedia('(max-width: 749px)').matches) return;
      const listRect = this.tabList.getBoundingClientRect();
      const rect = button.getBoundingClientRect();
      let left = this.tabList.scrollLeft;
      if (rect.left < listRect.left) left += rect.left - listRect.left - 4;
      if (rect.right > listRect.right) left += rect.right - listRect.right + 4;
      this.tabList.scrollTo({left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.updateScrollButtons();
    }
    activate(index) {
      this.buttons.forEach((button, position) => {
        button.setAttribute('aria-selected', String(position === index));
        button.tabIndex = position === index ? 0 : -1;
        this.panels[position].hidden = position !== index;
      });
      this.revealTab(this.buttons[index]);
    }
    disconnectedCallback() { this.controller?.abort(); this.tabResize?.disconnect(); }
  });
}
if (!customElements.get('life-dates-sticky-purchase')) {
  customElements.define('life-dates-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      const info = document.getElementById(`ProductInfo-${this.dataset.section}`);
      if (!info) return;
      this.controller = new AbortController();
      const stickyButton = this.querySelector('[data-sticky-add]');
      const nativeButton = () => info.querySelector('product-form [type="submit"]');
      const sync = () => {
        const button = nativeButton();
        stickyButton.disabled = !button || button.disabled;
        const price = info.querySelector('[id^="price-"] .price-item--regular');
        if (price) this.querySelector('[data-sticky-price]').textContent = price.textContent.trim();
      };
      stickyButton.addEventListener('click', () => nativeButton()?.click(), {signal:this.controller.signal});
      sync();
      this.mutations = new MutationObserver(sync);
      this.mutations.observe(info, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
      this.visibility = new IntersectionObserver(entries => {
        this.hidden = entries[0].isIntersecting || info.getBoundingClientRect().top > 0;
      }, {threshold:0});
      this.visibility.observe(info);
    }
    disconnectedCallback() { this.controller?.abort(); this.mutations?.disconnect(); this.visibility?.disconnect(); }
  });
}
